import { createFileRoute } from "@tanstack/react-router";
import { RepublishingPage } from "@/components/republishing/RepublishingPage";
import { republishingSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/republishing")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => republishingSeo(loaderData?.href ?? "/republishing"),
  component: RepublishingPage,
});
